import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { Sidebar, TwnelContext } from '@twnel/web-components';
import { SidebarConnect } from '@twnel/companies-login';

import { useNavigation } from 'utils';
import { DatepickerStyle, StyledToast } from './General';

const Container = SidebarConnect(Sidebar);

const Content = ({ getTexts = (val) => val, modules }) => (
  <TwnelContext>
    <DatepickerStyle />
    <StyledToast hideProgressBar closeButton={false} />
    <Routes>
      {modules.map(({
        Component, Fallback,
        moduleName, path, routePath,
      }) => (
        <Route
          key={`route:${path}`}
          path={routePath || path}
          element={(
            <Component
              fallback={Fallback ? <Fallback getTexts={getTexts} moduleName={moduleName} /> : null}
            />
          )}
        />
      ))}
    </Routes>
  </TwnelContext>
);

Content.propTypes = {
  getTexts: PropTypes.func,
  modules: PropTypes.arrayOf(PropTypes.shape({
    moduleName: PropTypes.string,
    Fallback: PropTypes.elementType,
    Component: PropTypes.elementType.isRequired,
    icon: PropTypes.string,
    path: PropTypes.string,
  })).isRequired,
};

const AppView = ({
  companyId = null, getTexts = (val) => val, modules,
  resetStore,
}) => {
  const { goTo, isPath } = useNavigation();

  useEffect(() => {
    if (companyId) {
      resetStore();
    }
  }, [companyId, resetStore]);

  return (
    <Container
      render={() => (<Content getTexts={getTexts} modules={modules} />)}
      options={modules.filter((module) => module.alt).map((module) => ({
        alt: module.alt,
        icon: module.icon,
        onClick: () => goTo(module.path),
        active: isPath(module.path, module.exact),
      }))}
    />
  );
};

AppView.propTypes = {
  companyId: PropTypes.string,
  getTexts: PropTypes.func,
  modules: PropTypes.arrayOf(PropTypes.shape({
    moduleName: PropTypes.string,
    Fallback: PropTypes.elementType,
    Component: PropTypes.elementType.isRequired,
    alt: PropTypes.string,
    icon: PropTypes.string,
    path: PropTypes.string,
  })).isRequired,
  resetStore: PropTypes.func.isRequired,
};

export default AppView;
